module.exports = __webpack_public_path__ + "static/img/0542_5.b8ee325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_5.jpg
// module id = xGNC
// module chunks = 1